<!-- 景点推荐详情页  mjs -->
<template>
 <div class="travelServe scenicspotdetailContainer">
   <!-- <div class="crumbs-1">
      <div class="container">
        <a href="/show/index">首页</a>
        <span>&gt;</span>
        <a href="#">景点推荐</a>
        <span>&gt;</span>
        <a href="#">详情页</a>
      </div>
    </div> -->
 <crumbs detail="true"/>
    <div class="container">
       <div class="dtop">
        <div class="content clearfix">
            <div class="banner">
                <span class="label"><i>{{scenicspotdetail.keyWord}}</i></span>
                <!-- Swiper -->
                <swiper :options="swiperOption"   class="swiper-container" id="banner">

                      <swiper-slide class="swiper-slide" v-for="(item,index) in imglist" :key="index">
                        <img :src="getImage(item)"  alt="">
                      </swiper-slide>

                    <!-- <div class="swiper-pagination"></div> -->
                </swiper>
            </div>
            <div class="rightBox">
                <div class="ditemtxt">
                    <div class="title clearfix">
                        <h2>{{scenicspotdetail.spotName}}</h2>
                        <h3><span>{{scenicspotdetail.keyWord}}</span></h3>
                    </div>
                    <p class="rank">景点观光综合排名<span>第<i>{{scenicspotdetail.hotList}}</i>位</span></p>
                    <div class="desc">
                      {{scenicspotdetail.introduction}}
                    </div>
                    <div class="bottomBox">
                      <div class="voiceGuide" v-if="scenicspotdetail.detailUrl!==undefined && scenicspotdetail.detailUrl !== '' ">
                        <a :href="scenicspotdetail.detailUrl">
                        语音导览</a>
                      </div>
                       <!-- <div class="itemfun clearfix">
                        <span class="browsevalue">
                          <i></i><em>1</em>
                        </span>
                        <span class="praisevalue" id="praisevalue">
                            <i></i>
                            <em>0</em>
                        </span>
                        <span class="collection" id="collection">
                            <i></i>
                            <em>0</em>
                        </span>
                    </div> -->
                    <pv pvtype="1" :count="pv" pv-style="iconpv1"/>
                    </div>

                </div>
            </div>
        </div>

        <div class="dmiddle content clearfix">
            <div class="jt">
                <h4>交通指南</h4>
                <div class="jttxt">
                {{scenicspotdetail.trafficGuide}}
                </div>
            </div>
            <div class="other w470">
                <div class="opendate">
                    <h4>开放时间</h4>
                    <div>{{scenicspotdetail.openTime}}</div>
                </div>
                <ul class="oul">
                    <li @click="openNew(scenicspotdetail.relevantStrategy)">
                          <img src="../../assets/common/images/icon-d1.png"  alt="">
                          <p>推荐攻略</p>
                    </li>
                    <li @click="openNew(scenicspotdetail.culturalTourism)">
                          <img src="../../assets/common/images/icon-d2.png"  alt="">
                          <p>文旅发现</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="dbttom">
            <div class="title"><span>景点详情</span><i></i></div>
            <ul class="fieldul clearfix">

                <li v-if="scenicspotdetail.keyWord !== undefined && scenicspotdetail.keyWord !== ''">
                  <label>类别</label>
                  <span>{{scenicspotdetail.keyWord}}</span>
                </li>
                <li v-if="scenicspotdetail.ticketPrice !== undefined && scenicspotdetail.ticketPrice !== ''">
                  <label>门票价格</label>
                  <span>{{scenicspotdetail.ticketPrice}}</span>
                </li>
                <li v-if="scenicspotdetail.place !== undefined && scenicspotdetail.place !== ''">
                  <label>地点</label>
                  <span>{{scenicspotdetail.place}}</span>
                </li>
                <li v-if="scenicspotdetail.famousScenery !== undefined && scenicspotdetail.famousScenery !== ''">
                  <label>著名景点</label>
                  <span>{{scenicspotdetail.famousScenery}}</span>
                </li>
                <li v-if="scenicspotdetail.suggestedTime !== undefined && scenicspotdetail.suggestedTime !== ''">
                  <label>建议游玩时长</label>
                  <span>{{scenicspotdetail.suggestedTime}}</span>
                </li>
                <li v-if="scenicspotdetail.suitableSeason !== undefined && scenicspotdetail.suitableSeason !== ''">
                  <label>适宜季节</label>
                  <span>{{scenicspotdetail.suitableSeason}}</span>
                </li>
            </ul>
            <div class="dbcontent">
<!-- 隐藏掉先 -->
                <!-- <div class="video_cont">
                        <div v-if="true" class="videosp" id="myvide">
                        </div>
                </div> -->
                <div class="con" v-html="scenicspotdetail.content">
                </div>
            </div>
            <comment v-if="scenicspotdetail" @commentcount="commentCount" @coffsettop="cOffsettop" v-show="isCommentshow"></comment>
        </div>

       </div>
    <right-sidebar @pvcount="pvcount" :comment-count="commentTotal" :comment-gotop="commentOffsettop" :comment-show="isCommentshow"
     :title="scenicspotdetail.spotName"
      :image="getImage(scenicspotdetail.image)"
      :url="this.$route.fullPath"
      ref="rightSidebar"></right-sidebar>
        <go-top></go-top>

    </div>
 </div>
</template>

<script>
import {getscenicdetail} from '@/api/scenicspot/index'
import Comment from '@/components/comment/index'
import RightSidebar from '@/components/rightsidebar/index'
import goTop from '@/components/gotop/index'
import crumbs from '@/components/crumbs/index'
import pv from '@/components/amount/pv'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'scenicspotdetail',
  components: {
    Comment,
    RightSidebar,
    goTop,
    crumbs,
    pv,
    swiper,
    swiperSlide
  },
  meta: {
    showHeader: true
  },
  data () {
    return {
      swiperOption: {
        // pagination: {
        //   el: '#banner .swiper-pagination'
        // },
        autoplay: {
          delay: 4000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        observer: true,
        observeParents: true
      },
      commentId: '',
      id: '',
      scenicspotdetail: {},
      isCommentshow: true, // 是否显示评论
      pv: 0,
      commentTotal: '',
      commentOffsettop: '',
      shortcont: '',
      imglist: []
    }
  },
  created () {
    this.id = this.$route.query.id
    this.getdetail()
  },
  methods: {
    getdetail () {
      getscenicdetail(this.id).then(res => {
        // console.log(res)
        this.scenicspotdetail = res.data.data
        this.imglist = res.data.data.images.split('|')
        this.shortcont = res.data.data.content.replace(/<.*?>/g, '')
      })
    },
    /* 评论总数 */
    commentCount (val) {
      this.commentTotal = val
    },
    /* 评论距顶部距离 */
    cOffsettop (val) {
      this.commentOffsettop = val
    },
    /* 浏览量 */
    pvcount (val) {
      this.pv = val
    },
    openNew (url) {
      if (url !== undefined && url !== '') {
        window.open(url)
      } else {
        this.$alert('暂无相关内容～', '', {
          confirmButtonText: '确定'
          // callback: action => {
          //   this.$message({
          //     type: 'info',
          //     message: `action: ${action}`
          //   })
          // }
        })
      }
    },
    getImage (val) {
      if (val === undefined || val === '') {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import "../../assets/common/scss/travleServes.scss";
</style>



// WEBPACK FOOTER //
// src/view/scenicspot/detail.vue